<template>
	<label class="form-control-label mb-3">
		<slot />
	</label>
</template>

<script>
	export default {
	
	}
</script>